import React from 'react'
import PropTypes from 'prop-types'
import markdownStyles from './index.module.scss'
import RichText from '../RichText'

const FaqAnswer = ({ content, collapsed, className }) => (
  <div
    className={`${markdownStyles.markdown} ${
      collapsed && markdownStyles.collapsed
    } ${className}`}
  >
    <RichText contentData={content} />
  </div>
)

FaqAnswer.defaultProps = {
  className: '',
}
FaqAnswer.propTypes = {
  content: PropTypes.object.isRequired,
  collapsed: PropTypes.bool.isRequired,
  className: PropTypes.string,
}

export default React.memo(FaqAnswer)
